import { useTranslation } from 'react-i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import AddVisit from '../../pages/AddVisit';
import AttachDocuments from '../../pages/AttachDocuments';
import { Bookings } from '../../pages/Bookings';
import { Documents } from '../../pages/Documents';
import ListingDetail from '../../pages/ListingDetail';
import Listings from '../../pages/Listings';
import NoMatch from '../../pages/NoMatch';
import PersonalInformation from '../../pages/PersonalInformation';
import Profile from '../../pages/Profile';
import SurveyAnswer from '../../pages/SurveyAnswer';
import TenantBookingCancellationPage from '../../pages/TenantBookingCancellationPage';
import ThankYou from '../../pages/ThankYou';
import UploadDocuments from '../../pages/UploadDocuments';
import UploadDocumentsSteps from '../../pages/UploadDocuments/UploadDocumentsSteps';
import Visit from '../../pages/Visit/Visit';
import '../../i18n';
import VisitQuestionnaire from '../../pages/VisitQuestionnaire';
import VisitRequestWasSent from '../../pages/VisitRequestWasSent';
import VisitWeAreSorry from '../../pages/VisitWeAreSorry';
import ProtectedRoute from './ProtectedRoute';

const Router = (): JSX.Element => {
  const { t } = useTranslation('routes');

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={`/:locale/${t('profile')}`}
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/${t('personal-information')}`}
          element={
            <ProtectedRoute>
              <PersonalInformation />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/${t('listings')}`}
          element={
            <ProtectedRoute>
              <Listings />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/${t('documents')}`}
          element={
            <ProtectedRoute>
              <Documents />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/${t('bookings')}`}
          element={
            <ProtectedRoute>
              <Bookings />
            </ProtectedRoute>
          }
        />
        <Route
          path={'/:locale/thankyou'}
          element={
            <ProtectedRoute>
              <ThankYou />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/${t('uploadDocuments')}`}
          element={
            <ProtectedRoute>
              <UploadDocuments />
            </ProtectedRoute>
          }
        >
          <Route
            path=":step"
            element={
              <ProtectedRoute>
                <UploadDocumentsSteps />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={`/:locale/${t('listings')}/:listingId`}
          element={
            <ProtectedRoute>
              <ListingDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/${t('attachDocuments')}`}
          element={
            <ProtectedRoute>
              <AttachDocuments />
            </ProtectedRoute>
          }
        />
        <Route
          path={`/:locale/visits/:visitId/questionnaire`}
          element={<VisitQuestionnaire />}
        />
        <Route
          path={`/:locale/properties/:propertyId/add-visit`}
          element={<AddVisit />}
        />
        <Route
          path={`/:locale/visits/:visitId/selection`}
          element={<Visit />}
        />
        <Route
          path={`/:locale/visits/:visitId/we-are-sorry`}
          element={<VisitWeAreSorry />}
        />
        <Route
          path={`/:locale/visits/:visitId/request-was-sent`}
          element={<VisitRequestWasSent />}
        />
        <Route path={`/:locale/surveys/:surveyId`} element={<SurveyAnswer />} />
        <Route
          path={`/:locale/tenant/bookings/:bookingId/cancellation`}
          element={
            <ProtectedRoute>
              <TenantBookingCancellationPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
